import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';
import '../../style/dashboard.css';
import WhatsappSlipButton from '../../component/WhatsappSlipButton';
import PracharButton from '../../component/PracharButton';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const VoterCaptainWiseVoter = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { appId, language, userId } = useAppId();
    const lang = language || 'en';

    const voterCaptainId = location.state?.userId || location.state?.user_id;

    // Helper function to convert Status 'D', 'C', 'P', 'N' to Full Form
    const getStatusFullForm = (statusCode) => {
        switch (statusCode?.toUpperCase()) {
            case 'D': return 'Doubtful';
            case 'C': return "Can't Say";
            case 'P': return 'Positive';
            case 'N': return 'Negative';
            default: return statusCode || 'Voted';
        }
    };

    // --- Translation Dictionary ---
    const t = {
        en: {
            pageTitle: "Voter Captain Wise Voter",
            userTitle: "Voter Captain :",
            voters: "Voters",
            serialNo: "Sr No.",
            name: "Name",
            mobile: "Mobile",
            idCardNo: "ID Card No",
            status: "Status",
            voted: "VOTED",
            notVoted: "NOT VOTED",
            noData: "No voters found for this voter captain.",
            loading: "Loading voters...",
            searchPlaceholder: "Search by Name, Mobile or ID Card No...",
            totalVoters: "Total Voters",
            totalVoted: "Total Voted",
            totalNotVoted: "Total Not Voted",
            backButton: "Back",
            fatherHusband: "F/S :",
            address: "Address :",
            houseNo: "House No :",
            pollingLoc: "Voting Loc :",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            family: "Family",
            print: "Print",
            addToGroup: "Add to Group",
            userName: "Name :",
            userMobile: "Mobile :",
            userDesignation: "Designation :",
            all: "All",
            votedFilter: "Voted",
            notVotedFilter: "Not Voted",
            totalMembers: "Total Members",
            totalVotingCount: "Total Voting",
            remainMembers: "Remain Members",
            addSurvey: "Add Survey",
            editMobileTitle: "Update Mobile Number",
            mobilePlaceholder: "Enter 10-digit mobile number",
            mobileErrorLength: "Mobile number must be 10 digits",
            mobileErrorStart: "Number must start with 6, 7, 8, or 9",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
            mobileUpdateSuccess: "Mobile number updated successfully!",
            mobileUpdateFailed: "Failed to update mobile number.",
            mobileUpdateError: "An error occurred while updating the mobile number.",
            mobileNotAvailable: "Mobile number is not available for this voter.",
            addressNotAvailable: "Address not available!"

        },
        hi: {
            pageTitle: "वोटर कैप्टन अनुसार मतदाता",
            userTitle: "वोटर कैप्टन :",
            voters: "मतदाता",
            serialNo: "क्र.सं.",
            name: "नाम",
            mobile: "मोबाइल",
            idCardNo: "पहचान पत्र नं",
            status: "स्थिति",
            voted: "मतदान किया",
            notVoted: "मतदान नहीं किया",
            noData: "इस वोटर कैप्टन के लिए कोई मतदाता नहीं मिला।",
            loading: "मतदाता लोड हो रहे हैं...",
            searchPlaceholder: "नाम, मोबाइल या पहचान पत्र नं से खोजें...",
            totalVoters: "कुल मतदाता",
            totalVoted: "कुल मतदान",
            totalNotVoted: "शेष मतदाता",
            backButton: "वापस",
            fatherHusband: "पिता/पति :",
            address: "पता :",
            houseNo: "घर नं :",
            pollingLoc: "मतदान स्थान :",
            call: "कॉल",
            text: "मैसेज",
            slip: "पर्ची",
            prachar: "प्रचार",
            family: "परिवार",
            print: "प्रिन्ट",
            addToGroup: "समूह में जोड़ें",
            userName: "नाम :",
            userMobile: "मोबाइल :",
            userDesignation: "पद :",
            all: "सभी",
            votedFilter: "मतदान किया",
            notVotedFilter: "मतदान नहीं किया",
            totalMembers: "कुल सदस्य",
            totalVotingCount: "कुल मतदान",
            remainMembers: "शेष सदस्य",
            addSurvey: "सर्वेक्षण जोड़ें",
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
            mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
            mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
            cancel: "रद्द करें",
            save: "सेव करें",
            saving: "सेव हो रहा है...",
            mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
            mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
            mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            addressNotAvailable: "पता उपलब्ध नहीं है!"

        },
        gu: {
            pageTitle: "વોટર કેપ્ટન વાઇઝ મતદાર",
            userTitle: "વોટર કેપ્ટન :",
            voters: "મતદારો",
            serialNo: "ક્ર.સં.",
            name: "નામ",
            mobile: "મોબાઇલ",
            idCardNo: "ઓળખ કાર્ડ નં",
            status: "સ્થિતિ",
            voted: "મતદાન કર્યું",
            notVoted: "મતદાન નથી કર્યું",
            noData: "આ વોટર કેપ્ટન માટે કોઈ મતદાર મળ્યા નથી.",
            loading: "મતદારો લોડ થઈ રહ્યા છે...",
            searchPlaceholder: "નામ, મોબાઇલ અથવા ઓળખ કાર્ડ નં દ્વારા શોધો...",
            totalVoters: "કુલ મતદાર",
            totalVoted: "કુલ મતદાન",
            totalNotVoted: "બાકી મતદાર",
            backButton: "પાછળ",
            fatherHusband: "પિતા/પતિ :",
            address: "સરનામું :",
            houseNo: "ઘર નં :",
            pollingLoc: "મતદાન સ્થળ :",
            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            family: "કુટુંબ",
            print: "પ્રિનટ",
            addToGroup: "જૂથમાં ઉમેરો",
            userName: "નામ :",
            userMobile: "મોબાઇલ :",
            userDesignation: "હોદ્દો :",
            all: "બધા",
            votedFilter: "મતદાન કર્યું",
            notVotedFilter: "મતદાન નથી કર્યું",
            totalMembers: "કુલ સભ્ય",
            totalVotingCount: "કુલ વોટિંગ",
            remainMembers: "બાકી સભ્ય",
            addSurvey: "સર્વે ઉમેરો",
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
            mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
            mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
            mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
            cancel: "રદ કરો",
            save: "સેવ કરો",
            saving: "સેવ થઈ રહ્યું છે...",
            mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
            mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
            mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!"

        }
    };

    const txt = t[lang] || t.gu;
    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);



    // --- Edit Mobile API Call ---
    const handleUpdateMobile = async () => {
        if (!newMobile || newMobile.length !== 10) {
            alert(txt.mobileErrorLength);
            return;
        }

        setIsSavingMobile(true);
        try {
            const payload = {
                app_id: appId?.toString(),
                voter_id: editingVoter.idcard_no,
                mobile_no: newMobile,
                modify_by: userId?.toString() || "1"
            };

            const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

            if (response.data.success || response.data.Success === "1") {
                alert(txt.mobileUpdateSuccess);
                setVoters(prev => prev.map(v =>
                    v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
                ));
                setIsEditMobileOpen(false);
            } else {
                alert(txt.mobileUpdateFailed);
            }
        } catch (error) {
            console.error("Error updating mobile:", error);
            alert(txt.mobileUpdateError);
        } finally {
            setIsSavingMobile(false);
        }
    };



    const [loading, setLoading] = useState(false);
    const [voters, setVoters] = useState([]);
    const [userInfo, setUserInfo] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterType, setFilterType] = useState('all'); // 'all', 'voted', 'notVoted', 'survey_available', 'survey_not_available', 'survey_pending'
    const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
    const [stats, setStats] = useState({
        total: 0,
        voted: 0,
        notVoted: 0
    });

    // --- Pagination State ---
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isFilterDropdownOpen && !event.target.closest('.filter-dropdown-container')) {
                setIsFilterDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isFilterDropdownOpen]);

    // Get filter button text
    const getFilterButtonText = () => {
        switch (filterType) {
            case 'voted': return txt.votedFilter;
            case 'notVoted': return txt.notVotedFilter;
            case 'survey_available': return "Survey Available";
            case 'survey_not_available': return "Survey Not Available";
            case 'survey_pending': return "Survey Pending";
            default: return txt.all;
        }
    };

    useEffect(() => {
        if (!appId) {
            navigate('/login');
            return;
        }

        if (!voterCaptainId) {
            navigate(-1);
            return;
        }

        const fetchVoterData = async () => {
            setLoading(true);
            try {
                const response = await axios.post(`${BASE_URL}/api/dis_voter_capation_wise_voter`, {
                    app_id: appId,
                    user_id: voterCaptainId
                });

                if (response.data.success && response.data.data) {
                    const voterList = response.data.data.result || [];

                    // Get user info from the response
                    if (voterList.length > 0) {
                        setUserInfo({
                            name: voterList[0].name || voterList[0].voter_captain_name,
                            mobile_no: voterList[0].mobile_no,
                            designation: voterList[0].designation || "Voter Captain",
                            total_members: voterList[0].total_members || voterList[0].total_phonebook_member,
                            total_voting: voterList[0].total_voting,
                            total_remain: voterList[0].total_remain,
                            voting_percent: voterList[0].voting_percent
                        });
                    }

                    setVoters(voterList);
                    setCurrentPage(1);
                    setFilterType('all');

                    // Calculate statistics
                    const votedCount = voterList.filter(voter => voter.is_voted === 1).length;
                    setStats({
                        total: voterList.length,
                        voted: votedCount,
                        notVoted: voterList.length - votedCount
                    });
                } else {
                    setVoters([]);
                    setUserInfo(null);
                    setStats({ total: 0, voted: 0, notVoted: 0 });
                }
            } catch (error) {
                console.error("Error fetching voter data:", error);
                setVoters([]);
            } finally {
                setLoading(false);
            }
        };

        fetchVoterData();
        // Auto refresh every 30 seconds
        const interval = setInterval(fetchVoterData, 30000);
        return () => clearInterval(interval);

    }, [appId, voterCaptainId, navigate]);

    // Filter voters by filterType and search term
    const getFilteredVoters = () => {
        let filtered = [...voters];

        // Apply status filter
        if (filterType === 'voted') {
            filtered = filtered.filter(voter => voter.is_voted === 1);
        } else if (filterType === 'notVoted') {
            filtered = filtered.filter(voter => voter.is_voted === 0);
        } else if (filterType === 'survey_available') {
            filtered = filtered.filter(voter => voter.voter_available === true);
        } else if (filterType === 'survey_not_available') {
            filtered = filtered.filter(voter => voter.voter_available === false);
        } else if (filterType === 'survey_pending') {
            filtered = filtered.filter(voter => voter.voter_available === null);
        }

        // Apply search term filter
        if (searchTerm) {
            const lowerSearch = searchTerm.toLowerCase();
            filtered = filtered.filter(voter =>
                (voter.eng_f_name && voter.eng_f_name.toLowerCase().includes(lowerSearch)) ||
                (voter.eng_surname && voter.eng_surname.toLowerCase().includes(lowerSearch)) ||
                (voter.contact_no && voter.contact_no.includes(lowerSearch)) ||
                (voter.idcard_no && voter.idcard_no.toLowerCase().includes(lowerSearch))
            );
        }

        return filtered;
    };

    const filteredVoters = getFilteredVoters();

    // --- Pagination Logic ---
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentVoters = filteredVoters.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredVoters.length / itemsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            if (currentPage <= 3) endPage = 4;
            if (currentPage >= totalPages - 2) startPage = totalPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    // --- Add to Group API Call ---
    const handleAddToGroup = async (voter) => {
        try {
            const payload = {
                app_id: appId?.toString(),
                user_id: userId?.toString() || appId?.toString(),
                idcard: voter.idcard_no
            };
            const response = await axios.post(`${BASE_URL}/api/ins_my_group`, payload);
            if (response.data.success) {
                alert("Added to group successfully!");
            } else {
                alert("Failed to add to group.");
            }
        } catch (error) {
            console.error("Error adding to group:", error);
            alert("An error occurred while adding to the group.");
        }
    };

    // Get status badge class
    const getStatusBadge = (status) => {
        return status === 1 ? 'status-voted' : 'status-not-voted';
    };

    // Get status text
    const getStatusText = (status) => {
        return status === 1 ? txt.voted : txt.notVoted;
    };

    // Handle filter click
    const handleFilterClick = (filter) => {
        setFilterType(filter);
        setCurrentPage(1);
        setIsFilterDropdownOpen(false);
    };

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert("Could not fetch family details.");
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert("Error generating message.");
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                // Open native SMS app with pre-filled body
                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };

    return (
        <div className="vcw-live-voter-page">
            <div className="header-wrapper shadow-sm">
                <Header title={txt.pageTitle} />
            </div>

            {/* Mobile Number Edit Modal */}
            {isEditMobileOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>{txt.editMobileTitle}</h4>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

                        <div style={{ marginBottom: '24px' }}>
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                placeholder={txt.mobilePlaceholder}
                                autoFocus
                            />
                            {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                                    {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                onClick={() => setIsEditMobileOpen(false)}
                                style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                {txt.cancel}
                            </button>
                            <button
                                onClick={handleUpdateMobile}
                                disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                                style={{
                                    padding: '10px 20px',
                                    background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                {isSavingMobile ? txt.saving : txt.save}
                            </button>
                        </div>
                    </div>
                </div>
            )}



            <div className="content-container container-fluid p-3 p-md-4 mx-auto">



                {/* Search Bar and Filter Dropdown */}
                <div className="search-filter-row mb-4">
                    <div className="search-wrapper">
                        <svg className="search-icon-main" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={txt.searchPlaceholder}
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                            }}
                        />
                        {searchTerm && (
                            <button className="clear-search-btn" onClick={() => setSearchTerm('')}>
                                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        )}
                    </div>

                    {/* Survey Status Filter Dropdown */}
                    <div className="filter-dropdown-container">
                        <button
                            className="filter-btn"
                            onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
                        >
                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
                            </svg>
                            {getFilterButtonText()}
                            <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <polyline points="6 9 12 15 18 9" />
                            </svg>
                        </button>

                        {isFilterDropdownOpen && (
                            <div className="filter-dropdown-menu">
                                <button
                                    className={`filter-option ${filterType === 'all' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('all')}
                                >
                                    {txt.all}
                                </button>
                                <button
                                    className={`filter-option ${filterType === 'survey_available' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('survey_available')}
                                >
                                    <span className="filter-dot available-dot"></span>
                                    Survey Available
                                </button>
                                <button
                                    className={`filter-option ${filterType === 'survey_not_available' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('survey_not_available')}
                                >
                                    <span className="filter-dot not-available-dot"></span>
                                    Survey Not Available
                                </button>
                                <button
                                    className={`filter-option ${filterType === 'survey_pending' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('survey_pending')}
                                >
                                    <span className="filter-dot pending-dot"></span>
                                    Survey Pending
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                {loading ? (
                    <div className="loader-wrapper">
                        <div className="spinner"></div>
                        <p className="loader-text">{txt.loading}</p>
                    </div>
                ) : currentVoters.length > 0 ? (
                    <>
                        <div className="row g-4 mt-1 pb-5">
                            {currentVoters.map((voter, index) => (
                                <div className="col-12 col-md-6 col-lg-4" key={voter.id || index}>
                                    <div className="voter-card-clean h-100">
                                        {/* Header with Survey Status */}
                                        <div className="voter-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div>
                                                <span className="serial-number">{indexOfFirstItem + index + 1}.</span>
                                                <span className="voter-name-bold ms-2">{voter.eng_f_name} {voter.eng_surname || ''}</span>
                                            </div>
                                            <div>
                                                {voter.voter_available === null && (
                                                    <button
                                                        className="btn-add-survey"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            // 🔴 અહીં આપણે આખા 'voter' ઓબ્જેક્ટને state દ્વારા પાસ કરીએ છીએ
                                                            navigate('/voter_survey_form', { state: { voter: voter } });
                                                        }}
                                                    >
                                                        + {txt.addSurvey}
                                                    </button>
                                                )}
                                                {voter.voter_available === true && (
                                                    <span className="badge-status status-positive">
                                                        {getStatusFullForm(voter.voter_status)}
                                                    </span>
                                                )}
                                                {voter.voter_available === false && (
                                                    <span className="badge-status status-negative">
                                                        {voter.not_available_reason || 'Not Available'}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="voter-body position-relative">
                                            <div
                                                className="map-icon-wrapper"
                                                style={{ cursor: 'pointer', zIndex: 10 }}
                                                title="View on Google Maps"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    const address = voter.eng_localityid;
                                                    if (address && address !== "N/A") {
                                                        // ગુગલ મેપ્સમાં એડ્રેસ સર્ચ કરવા માટેની લિંક
                                                        window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
                                                    } else {
                                                        alert("Address not available!");
                                                    }
                                                }}
                                            >
                                                <img src="https://upload.wikimedia.org/wikipedia/commons/a/aa/Google_Maps_icon_%282020%29.svg" alt="Map" width="15" />
                                            </div>
                                            <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{voter.eng_m_name || "N/A"}</span></div>
                                            <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                            <div className="info-row"><span className="label">{txt.serialNo}</span><span className="value">{voter.slnoinpart || "N/A"}</span></div>
                                            <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                                <span className="label">{txt.mobile}</span>
                                                <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                                <svg
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setEditingVoter(voter);
                                                        setNewMobile(voter.contact_no || '');
                                                        setIsEditMobileOpen(true);
                                                    }}
                                                    style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                                    fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                                >
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                </svg>
                                            </div>
                                            <div className="info-row"><span className="label">{txt.idCardNo}</span><span className="value">{voter.idcard_no || "N/A"}</span></div>
                                            <div className="info-row"><span className="label">Booth No</span><span className="value">{voter.part_no || voter.booth_no || "N/A"}</span></div>
                                            <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no || "N/A"}</span></div>
                                            <div className="info-row"><span className="label">{txt.pollingLoc}</span><span className="value">{voter.eng_polling_location || "-"}</span></div>
                                        </div>
                                        <div className="voter-actions">
                                            <ActionButton icon="📞" color="#0ea5e9" label={txt.call}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                                        alert("Mobile number is not available for this voter.");
                                                    }
                                                    else {
                                                        window.open(`tel:${voter.contact_no}`, '_blank');
                                                    }
                                                }}

                                            />
                                            <ActionButton icon="✉️" color="#f59e0b" label={txt.text} onClick={() => handleSmsShare(voter)} />
                                            {/* નવો કોડ */}
                                            <WhatsappSlipButton voter={voter} />
                                            {/* નોંધ: જો map માં વેરીએબલ નું નામ member હોય, તો voter={member} પાસ કરજો */}
                                            <ActionButton
                                                icon="🖨"
                                                color="#f97316"
                                                label={txt.print}
                                                onClick={() => navigate('/printer', { state: { voter_id: voter.id } })}
                                            />
                                            <PracharButton voter={voter} />
                                            <ActionButton icon="👨‍👩‍👧" color="#fbbf24" label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Pagination */}
                        {filteredVoters.length > itemsPerPage && (
                            <div className="pagination-wrapper">
                                <div className="pagination-content">
                                    <button className="pagination-nav-btn" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                                    </button>
                                    <div className="page-numbers">
                                        {getPageNumbers().map((number, index) => (
                                            <React.Fragment key={index}>
                                                {number === '...' ? (<span className="page-dots">...</span>) : (
                                                    <button className={`page-num-btn ${currentPage === number ? 'active' : ''}`} onClick={() => paginate(number)}>{number}</button>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <button className="pagination-nav-btn" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                    </button>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="text-center text-muted p-4 bg-white rounded shadow-sm border slide-up-element">
                        {txt.noData}
                    </div>
                )}
            </div>

            <style jsx>{`
                .vcw-live-voter-page { width: 100%; min-height: 100vh; background: #E5E7EB; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; padding-bottom: 40px; }
                .header-wrapper { background: white; padding: 0 24px; position: sticky; top: 0; z-index: 50; }

                /* User Info Card */
                .user-info-card {
                    background: white;
                    border-radius: 16px;
                    padding: 20px;
                    margin-bottom: 20px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
                    border: 1px solid #e2e8f0;
                }
                .user-info-header {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 16px;
                    padding-bottom: 16px;
                    border-bottom: 1px solid #e2e8f0;
                }
                .user-avatar {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 24px;
                    font-weight: 700;
                }
                .user-details {
                    flex: 1;
                }
                .user-name {
                    margin: 0;
                    font-size: 18px;
                    font-weight: 800;
                    color: #0f172a;
                }
                .user-designation {
                    margin: 4px 0;
                    font-size: 13px;
                    color: #64748b;
                }
                .user-mobile {
                    margin: 0;
                    font-size: 13px;
                    color: #475569;
                    font-weight: 500;
                }
                .user-stats {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                }
                .user-stat-item {
                    text-align: center;
                    flex: 1;
                }
                .user-stat-value {
                    display: block;
                    font-size: 20px;
                    font-weight: 800;
                    color: #1e293b;
                }
                .user-stat-label {
                    font-size: 11px;
                    font-weight: 600;
                    color: #64748b;
                    text-transform: uppercase;
                }
                .user-stat-divider {
                    width: 1px;
                    height: 30px;
                    background: #e2e8f0;
                }

                /* Stats Filter Container */
                .stats-filter-container {
                    margin-bottom: 20px;
                }
                .stats-container {
                    display: flex;
                    gap: 16px;
                    flex-wrap: wrap;
                }
                .stat-card {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    background: white;
                    padding: 16px 20px;
                    border-radius: 14px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
                    border: 1px solid #e2e8f0;
                    transition: all 0.2s ease;
                    cursor: pointer;
                }
                .stat-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
                }
                .stat-card.active-filter {
                    border: 2px solid;
                    transform: scale(1.02);
                    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
                }
                .total-card { border-left: 4px solid #3b82f6; }
                .total-card.active-filter { border: 2px solid #3b82f6; background: #eff6ff; }
                .voted-card { border-left: 4px solid #10b981; }
                .voted-card.active-filter { border: 2px solid #10b981; background: #ecfdf5; }
                .not-voted-card { border-left: 4px solid #f59e0b; }
                .not-voted-card.active-filter { border: 2px solid #f59e0b; background: #fffbeb; }
                .stat-icon { font-size: 32px; }
                .stat-info { display: flex; flex-direction: column; }
                .stat-label { font-size: 12px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; }
                .stat-value { font-size: 28px; font-weight: 800; color: #0f172a; line-height: 1.2; }
                .total-card .stat-value { color: #3b82f6; }
                .voted-card .stat-value { color: #10b981; }
                .not-voted-card .stat-value { color: #f59e0b; }

                /* Search and Filter Row */
                .search-filter-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 20px;
                }
                .search-wrapper { 
                    position: relative; 
                    flex: 1; 
                }
                .search-icon-main { 
                    position: absolute; 
                    left: 14px; 
                    top: 50%; 
                    transform: translateY(-50%); 
                    color: #94a3b8; 
                    width: 20px; 
                    height: 20px; 
                    z-index: 1;
                }
                .search-input { 
                    width: 100%; 
                    padding: 12px 42px 12px 42px; 
                    border: 1px solid #e2e8f0; 
                    border-radius: 10px; 
                    font-size: 14px; 
                    color: #1e293b; 
                    outline: none; 
                    transition: all 0.2s ease; 
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05); 
                }
                .search-input:focus { 
                    border-color: #2563eb; 
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); 
                }
                .clear-search-btn {
                    position: absolute;
                    right: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #f1f5f9;
                    border: none;
                    border-radius: 50%;
                    padding: 6px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #64748b;
                    transition: all 0.2s;
                }
                .clear-search-btn:hover {
                    background: #e2e8f0;
                }

                /* Filter Dropdown Styles */
                .filter-dropdown-container {
                    position: relative;
                }
                .filter-btn {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    padding: 10px 16px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #1e293b;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                }
                .filter-btn:hover {
                    background: #f8fafc;
                    border-color: #cbd5e1;
                }
                .filter-dropdown-menu {
                    position: absolute;
                    top: 100%;
                    right: 0;
                    margin-top: 8px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
                    min-width: 180px;
                    z-index: 100;
                    overflow: hidden;
                }
                .filter-option {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    width: 100%;
                    padding: 10px 16px;
                    border: none;
                    background: white;
                    font-size: 13px;
                    font-weight: 500;
                    color: #334155;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    text-align: left;
                }
                .filter-option:hover {
                    background: #f1f5f9;
                }
                .filter-option.active {
                    background: #eff6ff;
                    color: #2563eb;
                }
                .filter-dot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    display: inline-block;
                }
                .available-dot {
                    background-color: #22c55e;
                }
                .not-available-dot {
                    background-color: #ef4444;
                }
                .pending-dot {
                    background-color: #f59e0b;
                }

                /* Add Survey Button */
                .btn-add-survey {
                    background-color: #3b82f6;
                    color: white;
                    border: none;
                    border-radius: 16px;
                    font-size: 11px;
                    font-weight: 600;
                    padding: 4px 12px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                }
                .btn-add-survey:hover {
                    background-color: #2563eb;
                    transform: translateY(-1px);
                }

                /* Status Badges */
                .badge-status {
                    display: inline-block;
                    border-radius: 16px;
                    font-size: 11px;
                    font-weight: 600;
                    padding: 4px 12px;
                    white-space: nowrap;
                    display: inline-flex;
                    align-items: center;
                }
                .status-positive {
                    background-color: #dcfce7;
                    color: #166534;
                    border: 1px solid #bbf7d0;
                }
                .status-negative {
                    background-color: #fee2e2;
                    color: #991b1b;
                    border: 1px solid #fecaca;
                }

                /* Status Badge for Voted/Not Voted */
                .status-badge {
                    display: inline-block;
                    padding: 2px 8px;
                    border-radius: 12px;
                    font-size: 10px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }
                .status-voted {
                    background: #dcfce7;
                    color: #166534;
                }
                .status-not-voted {
                    background: #fee2e2;
                    color: #991b1b;
                }

                /* Loader */
                .loader-wrapper { 
                    display: flex; 
                    flex-direction: column; 
                    justify-content: center; 
                    align-items: center; 
                    min-height: 40vh; 
                    width: 100%; 
                }
                .spinner { 
                    width: 40px; 
                    height: 40px; 
                    border: 4px solid #E5E7EB; 
                    border-top: 4px solid #2563EB; 
                    border-radius: 50%; 
                    animation: spin 1s linear infinite; 
                    margin-bottom: 12px; 
                }
                .loader-text { 
                    color: #6B7280; 
                    font-weight: 500; 
                }
                @keyframes spin { 
                    0% { transform: rotate(0deg); } 
                    100% { transform: rotate(360deg); } 
                }

                /* Pagination */
                .pagination-wrapper { 
                    display: flex; 
                    justify-content: center; 
                    padding: 20px 0; 
                    position: sticky; 
                    bottom: 20px; 
                    z-index: 50; 
                    pointer-events: none; 
                }
                .pagination-content { 
                    background: white; 
                    border: 1px solid #E2E8F0; 
                    border-radius: 50px; 
                    padding: 8px 16px; 
                    display: flex; 
                    align-items: center; 
                    gap: 10px; 
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1); 
                    pointer-events: auto; 
                }
                .pagination-nav-btn { 
                    display: flex; 
                    align-items: center; 
                    justify-content: center; 
                    width: 36px; 
                    height: 36px; 
                    border-radius: 50%; 
                    background: transparent; 
                    border: none; 
                    color: #2563EB; 
                    cursor: pointer; 
                }
                .pagination-nav-btn:disabled { 
                    color: #CBD5E1; 
                    cursor: not-allowed; 
                }
                .page-numbers { 
                    display: flex; 
                    gap: 5px; 
                    align-items: center; 
                }
                .page-num-btn { 
                    width: 32px; 
                    height: 32px; 
                    border-radius: 50%; 
                    border: 1px solid transparent; 
                    background: transparent; 
                    color: #475569; 
                    font-weight: 600; 
                    font-size: 14px; 
                    cursor: pointer; 
                }
                .page-num-btn.active { 
                    background-color: #2563EB; 
                    color: white; 
                }
                .page-dots { 
                    color: #94A3B8; 
                    font-weight: bold; 
                    padding: 0 4px; 
                }

                /* Animation */
                .slide-up-element { animation: slideUp 0.4s ease forwards; opacity: 0; }
                @keyframes slideUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }

                /* Responsive */
                @media (max-width: 768px) {
                    .stats-container { flex-direction: column; gap: 12px; }
                    .stat-card { padding: 12px 16px; }
                    .stat-value { font-size: 24px; }
                    .stat-icon { font-size: 28px; }
                    .voter-actions { gap: 6px; }
                    .circle-btn { width: 32px; height: 32px; font-size: 14px; }
                    .btn-label { font-size: 9px; }
                    .user-info-header { flex-direction: column; text-align: center; }
                    .user-avatar { width: 50px; height: 50px; font-size: 20px; }
                    .search-filter-row { flex-direction: column; }
                    .filter-dropdown-container { width: 100%; }
                    .filter-btn { justify-content: center; width: 100%; }
                    .filter-dropdown-menu { right: auto; left: 0; width: 100%; }
                }

                @media (max-width: 480px) {
                    .info-row .label { width: 85px; font-size: 11px; }
                    .info-row .value { font-size: 11px; }
                    .voter-header { padding: 10px 12px; }
                    .voter-name-bold { font-size: 13px; }
                    .pagination-content { padding: 6px 12px; }
                    .page-num-btn { width: 28px; height: 28px; font-size: 12px; }
                    .pagination-nav-btn { width: 32px; height: 32px; }
                    .user-stats { flex-direction: column; gap: 12px; }
                    .user-stat-divider { width: 80%; height: 1px; margin: 0 auto; }
                    .btn-add-survey { font-size: 10px; padding: 3px 10px; }
                    .badge-status { font-size: 10px; padding: 3px 10px; }
                }
            `}</style>
        </div>
    );
};

// ActionButton Component
const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default VoterCaptainWiseVoter;